import * as React from "react";
import "../../styles/component/layout/SearchResultPageLayout.scss";
import "../../styles/component/layout/PageBaseLayout.scss";
import { loadComponent } from "@amzn/legal-client-utilities";
import { AppContext } from "../../setup/context";
import { SourceMfePreloader } from "./SourceMfePreloader";

type MatterSmartSearch = React.ComponentType<{instanceId: string, filterText: string}>;

export const SourceMatterSmartSearch = (props: {
    instanceId: string
    filterText: string
}) => {
    const context = React.useContext(AppContext);
    const remoteEntryUrl = `${context.config.source.url}/federated/remoteEntry.js`;

    const SmartSearchMatterMFE: MatterSmartSearch = React.lazy(() =>
        loadComponent("source2_provider", "./MatterSmartSearch", remoteEntryUrl, false)
    );

    window["remotes"] = {
        source2_provider: remoteEntryUrl
    };

    return (
        <SourceMfePreloader>
            <React.Suspense  fallback={<div>Loading...</div>}>
                <>
                    <SmartSearchMatterMFE
                        key={props.filterText}
                        instanceId={props.instanceId}
                        filterText={props.filterText}
                    />
                </>
            </React.Suspense>
        </SourceMfePreloader>
    );
};
